var _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrganizeWorkflowImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 640,
    viewBox: "0 0 160 640",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Mask group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1868_13898",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 160,
    height: 640
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "organize-workflow-mask-elements"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    width: 32,
    height: 8,
    rx: 4,
    fill: "#212036"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2",
    y: 16,
    width: 20,
    height: 8,
    rx: 4,
    fill: "#212036"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3",
    x: 64,
    width: 32,
    height: 8,
    rx: 4,
    fill: "#212036"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4",
    x: 64,
    y: 16,
    width: 20,
    height: 8,
    rx: 4,
    fill: "#212036"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5",
    x: 128,
    width: 32,
    height: 8,
    rx: 4,
    fill: "#212036"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6",
    x: 128,
    y: 16,
    width: 20,
    height: 8,
    rx: 4,
    fill: "#212036"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7",
    y: 56,
    width: 32,
    height: 8,
    rx: 4,
    fill: "#212036"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8",
    y: 72,
    width: 20,
    height: 8,
    rx: 4,
    fill: "#212036"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9",
    x: 64,
    y: 56,
    width: 32,
    height: 8,
    rx: 4,
    fill: "#212036"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10",
    x: 64,
    y: 72,
    width: 20,
    height: 8,
    rx: 4,
    fill: "#212036"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11",
    x: 128,
    y: 56,
    width: 32,
    height: 8,
    rx: 4,
    fill: "#212036"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12",
    x: 128,
    y: 72,
    width: 20,
    height: 8,
    rx: 4,
    fill: "#212036"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_13",
    y: 112,
    width: 32,
    height: 8,
    rx: 4,
    fill: "#212036"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_14",
    y: 128,
    width: 20,
    height: 8,
    rx: 4,
    fill: "#212036"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_15",
    x: 64,
    y: 112,
    width: 32,
    height: 8,
    rx: 4,
    fill: "#212036"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_16",
    x: 64,
    y: 128,
    width: 20,
    height: 8,
    rx: 4,
    fill: "#212036"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17",
    x: 128,
    y: 112,
    width: 32,
    height: 8,
    rx: 4,
    fill: "#212036"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18",
    x: 128,
    y: 128,
    width: 20,
    height: 8,
    rx: 4,
    fill: "#212036"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19",
    y: 168,
    width: 32,
    height: 8,
    rx: 4,
    fill: "#212036"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_20",
    y: 184,
    width: 20,
    height: 8,
    rx: 4,
    fill: "#212036"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_13"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_21",
    x: 64,
    y: 168,
    width: 32,
    height: 8,
    rx: 4,
    fill: "#212036"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22",
    x: 64,
    y: 184,
    width: 20,
    height: 8,
    rx: 4,
    fill: "#212036"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_14"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23",
    x: 128,
    y: 168,
    width: 32,
    height: 8,
    rx: 4,
    fill: "#212036"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24",
    x: 128,
    y: 184,
    width: 20,
    height: 8,
    rx: 4,
    fill: "#212036"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_15"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25",
    y: 224,
    width: 32,
    height: 8,
    rx: 4,
    fill: "#212036"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26",
    y: 240,
    width: 20,
    height: 8,
    rx: 4,
    fill: "#212036"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_16"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27",
    x: 64,
    y: 224,
    width: 32,
    height: 8,
    rx: 4,
    fill: "#212036"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_28",
    x: 64,
    y: 240,
    width: 20,
    height: 8,
    rx: 4,
    fill: "#212036"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_17"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_29",
    x: 128,
    y: 224,
    width: 32,
    height: 8,
    rx: 4,
    fill: "#212036"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_30",
    x: 128,
    y: 240,
    width: 20,
    height: 8,
    rx: 4,
    fill: "#212036"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_18"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31",
    y: 280,
    width: 32,
    height: 8,
    rx: 4,
    fill: "#212036"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_32",
    y: 296,
    width: 20,
    height: 8,
    rx: 4,
    fill: "#212036"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_19"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_33",
    x: 64,
    y: 280,
    width: 32,
    height: 8,
    rx: 4,
    fill: "#212036"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_34",
    x: 64,
    y: 296,
    width: 20,
    height: 8,
    rx: 4,
    fill: "#212036"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_20"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_35",
    x: 128,
    y: 280,
    width: 32,
    height: 8,
    rx: 4,
    fill: "#212036"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_36",
    x: 128,
    y: 296,
    width: 20,
    height: 8,
    rx: 4,
    fill: "#212036"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_21"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_37",
    y: 336,
    width: 32,
    height: 8,
    rx: 4,
    fill: "#212036"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_38",
    y: 352,
    width: 20,
    height: 8,
    rx: 4,
    fill: "#212036"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_22"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_39",
    x: 64,
    y: 336,
    width: 32,
    height: 8,
    rx: 4,
    fill: "#212036"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_40",
    x: 64,
    y: 352,
    width: 20,
    height: 8,
    rx: 4,
    fill: "#212036"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_23"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_41",
    x: 128,
    y: 336,
    width: 32,
    height: 8,
    rx: 4,
    fill: "#212036"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_42",
    x: 128,
    y: 352,
    width: 20,
    height: 8,
    rx: 4,
    fill: "#212036"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_24"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_43",
    y: 392,
    width: 32,
    height: 8,
    rx: 4,
    fill: "#212036"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_44",
    y: 408,
    width: 20,
    height: 8,
    rx: 4,
    fill: "#212036"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_25"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_45",
    x: 64,
    y: 392,
    width: 32,
    height: 8,
    rx: 4,
    fill: "#212036"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_46",
    x: 64,
    y: 408,
    width: 20,
    height: 8,
    rx: 4,
    fill: "#212036"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_26"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_47",
    x: 128,
    y: 392,
    width: 32,
    height: 8,
    rx: 4,
    fill: "#212036"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_48",
    x: 128,
    y: 408,
    width: 20,
    height: 8,
    rx: 4,
    fill: "#212036"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_27"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_49",
    y: 448,
    width: 32,
    height: 8,
    rx: 4,
    fill: "#212036"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_50",
    y: 464,
    width: 20,
    height: 8,
    rx: 4,
    fill: "#212036"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_28"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_51",
    x: 64,
    y: 448,
    width: 32,
    height: 8,
    rx: 4,
    fill: "#212036"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_52",
    x: 64,
    y: 464,
    width: 20,
    height: 8,
    rx: 4,
    fill: "#212036"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_29"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_53",
    x: 128,
    y: 448,
    width: 32,
    height: 8,
    rx: 4,
    fill: "#212036"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_54",
    x: 128,
    y: 464,
    width: 20,
    height: 8,
    rx: 4,
    fill: "#212036"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_30"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_55",
    y: 504,
    width: 32,
    height: 8,
    rx: 4,
    fill: "#212036"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_56",
    y: 520,
    width: 20,
    height: 8,
    rx: 4,
    fill: "#212036"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_31"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_57",
    x: 64,
    y: 504,
    width: 32,
    height: 8,
    rx: 4,
    fill: "#212036"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_58",
    x: 64,
    y: 520,
    width: 20,
    height: 8,
    rx: 4,
    fill: "#212036"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_32"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_59",
    x: 128,
    y: 504,
    width: 32,
    height: 8,
    rx: 4,
    fill: "#212036"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_60",
    x: 128,
    y: 520,
    width: 20,
    height: 8,
    rx: 4,
    fill: "#212036"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_33"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_61",
    y: 560,
    width: 32,
    height: 8,
    rx: 4,
    fill: "#212036"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_62",
    y: 576,
    width: 20,
    height: 8,
    rx: 4,
    fill: "#212036"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_34"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_63",
    x: 64,
    y: 560,
    width: 32,
    height: 8,
    rx: 4,
    fill: "#212036"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_64",
    x: 64,
    y: 576,
    width: 20,
    height: 8,
    rx: 4,
    fill: "#212036"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_35"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_65",
    x: 128,
    y: 560,
    width: 32,
    height: 8,
    rx: 4,
    fill: "#212036"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_66",
    x: 128,
    y: 576,
    width: 20,
    height: 8,
    rx: 4,
    fill: "#212036"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_36"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_67",
    y: 616,
    width: 32,
    height: 8,
    rx: 4,
    fill: "#212036"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_68",
    y: 632,
    width: 20,
    height: 8,
    rx: 4,
    fill: "#212036"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_37"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_69",
    x: 64,
    y: 616,
    width: 32,
    height: 8,
    rx: 4,
    fill: "#212036"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_70",
    x: 64,
    y: 632,
    width: 20,
    height: 8,
    rx: 4,
    fill: "#212036"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_38"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_71",
    x: 128,
    y: 616,
    width: 32,
    height: 8,
    rx: 4,
    fill: "#212036"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_72",
    x: 128,
    y: 632,
    width: 20,
    height: 8,
    rx: 4,
    fill: "#212036"
  })), /*#__PURE__*/React.createElement("g", {
    id: "organize-workflow-mask-circle"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse",
    cx: 79.7969,
    cy: 122,
    r: 24,
    fill: "#5C6381"
  })))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1868_13898)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_2",
    filter: "url(#filter0_f_1868_13898)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 5.94336,
    cy: 97.7402,
    r: 153.396,
    fill: "url(#paint0_radial_1868_13898)"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_1868_13898",
    x: -276.653,
    y: -184.856,
    width: 565.197,
    height: 565.197,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 64.6,
    result: "effect1_foregroundBlur_1868_13898"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_1868_13898",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(5.94336 97.7402) rotate(90) scale(153.396)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9A88DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.905,
    stopColor: "#0A0219"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrganizeWorkflowImg);
export default __webpack_public_path__ + "static/media/OrganizeWorkflowImg.50a71383de13f29f37c7565f956ecf97.svg";
export { ForwardRef as ReactComponent };